import type { NavigationPlaceDescriptor } from '@efficiently/client-core-navigation';
import { PROJECTS_MODULE_ROUTES, toRouteParam } from '@efficiently/client-core-routing';

import { DIVISION_NAVIGATION_KEY } from '../../../navigation/division-navigation-key.constant';
import { KONVA_CONSTRUCTIONS_ROUTES } from '../constructions/constructions-routing.const';

/** One page of a Construction Set in Design Plans, a place the agent may open. */
export const DESIGN_PLANS_CONSTRUCTION_NAVIGATION_PLACE: NavigationPlaceDescriptor = {
	placeKey: 'design-plans-construction',
	path: KONVA_CONSTRUCTIONS_ROUTES.DETAIL.fullPath(
		toRouteParam(PROJECTS_MODULE_ROUTES.ROOT.PARAMS.PROJECT_ID),
		toRouteParam(KONVA_CONSTRUCTIONS_ROUTES.DETAIL.PARAMS.PLAN_ITEM_ID),
	),
	keys: [DIVISION_NAVIGATION_KEY],
};
